import Component from "../ways-to-watch/subscription"
export default Component
